import request from "root/js/request";

export const postUploadExpensesTemplateCrossMP = async ({ cabinet_id, formData }) => {
  const file = formData.get("excel_file"); // subject to change
  if (file) {
    formData.delete("excel_file");
    formData.append("file", file);
  }

  const response = await request({
    url: `/api/analytics/cross-mp/expense/group/upload_expense/`,
    method: "post",
    params: {
      cabinet_id,
    },
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    },
  });

  return response;
};
